import { type DomainAccessControlConfig } from 'domains/catalog-admin/utils/domain/accessControl'
import { Permission } from 'domains/catalog-admin/access-control/permissions'

export const catalogAdminCatalogImageUploadsAccessConfiguration: DomainAccessControlConfig = {
  permissions: [Permission.ImageUploadsViewAccess],
}
